import MobileDetect from 'mobile-detect';

export const noop = () => {};

/**
 * Util JSON parse wrapper, used for configuration lists
 */
export function parseJsonOrNull (data) {
    try {
        return JSON.parse(data);
    } catch (error) {
        return null;
    }
}

const detect = new MobileDetect(window.navigator.userAgent);

/**
 * Information about the current device
 */
export const device = {
    userAgent: detect.ua,
    phone: detect.phone(),
    tablet: detect.tablet(),
    os: detect.os(),
    get isMobile () {
        return !!this.phone;
    },
    get isDesktop () {
        return !this.phone && !this.tablet;
    },
};

export const isFromRouter = !!window.teester;

/**
 * Ensure a given URL ends with a trailing slash
 */
export const formatUrl = (str) => str + (str.endsWith('/') ? '' : '/');

/**
 * Concatenates an array of elements into one string removing nulls or undefiled.
 * @param array
 * @param separator
 */
export const getTextFromArray = (array, separator = ' ') => array.filter(Boolean).join(separator);
